<template>
  <div>
    <div ref="ios_mask" class="mask">
      <img src="~@/assets/arrow.png" style="margin: 1rem 0 0 2.5rem;" />
      <p style="color: #ffffff;font-size: 23px;margin:.5rem 0 .9rem 0;">
        请在浏览器中打开
      </p>
      <img src="~@/assets/know.png" style="CURSOR: pointer" />
    </div>
    <!--上半部分-->
    <div>
      <img class="topbg" src="../assets/topbg_mobile.png" />
      <div class="top_content">
        <img class="app_icon" src="../assets/icon2.png" />
        <font class="app_name">漫步今日益行</font>
      </div>
      <font class="des">连续打卡全额返 就在漫步今日益行</font>
      <div class="btnP">
        <div @click="jump()">
          <img class="btnImg" src="~@/assets/bot.png" />
          <!-- <a href="https://s3.cn-northwest-1.amazonaws.com.cn/s3.jianos.com/Zero.apk" download="" traget="_blank"> -->
          <font class="btnFont">iOS系统下载</font>
          <!-- </a> -->
        </div>
      </div>
    </div>
    <!--下半部分-->
    <div style="margin-bottom:30px">
      <img class="img1" src="~@/assets/right_top.png" />
      <div class="WordP">
        <h1>打卡简单 全额返购自主提现</h1>
        <div>只要坚持完成连续打卡任务 即全额返现</div>
        <p>• 进入指定京东或天猫店铺购买想要的指定商品</p>
        <p style="margin:3px 0">• 进入漫步今日益行注册账号，关联商品</p>
        <p>• 每日打卡，完成阶段任务自主提现，直至全额</p>
      </div>
      <img class="img1" src="~@/assets/left_bottom.png" />
      <div class="WordP">
        <h1>提现便捷 拒绝意外翻车</h1>
        <div>分阶段返现，完成阶段任务即可直接提现</div>
        <p>• 在漫步今日益行打卡至阶段任务完成</p>
        <p style="margin:3px 0">• 进入领奖处，填写收款账户直接申请提现</p>
        <p>• 全部现金到账，更有神秘福利免费领取</p>
      </div>
    </div>
  </div>
</template>
<!--(1920 px 1082 px)-->
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mask {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  width: 100%;
  min-height: 100vh;
  background-color: #555555f0;
  display: block;
  z-index: 10;
}

.topbg {
  width: 100%;
  height: auto;
}

.top_content {
  width: auto;
  left: 18%;
  top: 13%;
  position: absolute;
  text-align: left;
  display: flex;
  align-items: center;
}

.app_icon {
  width: 60px;
  height: 60px;
  border-radius: 13px;
}

.app_name {
  font-size: 30px;
  font-weight: bold;
  margin-left: 25px;
}

.des {
  color: #fb4644;
  font-weight: bold;
  font-size: 16px;
  left: 18%;
  top: 24%;
  position: absolute;
}

.btnP {
  position: absolute;
  bottom: 6%;
  display: flex;
  justify-content: center;
  width: 100%;
  height: auto;
}

.btnP div {
  background-color: #fb4644;
  display: flex;
  align-items: center;
  width: auto;
  height: auto;
  border-radius: 20px;
  padding: 5px;
  padding-left: 10px;
  padding-right: 20px;
}

.btnP:active {
  /*transform: scale(10);*/
}

.btnImg {
  width: 30px;
  height: 30px;
}

.btnFont {
  color: white;
  font-size: 20px;
  font-weight: bold;
  margin-left: 10px;
}

.btnFont:active {
  font-size: 18px;
}

.img1 {
  width: 80%;
  height: auto;
  margin-top: 20px;
}

.WordP {
  width: 100%;
  height: auto;
  text-align: center;
}

.WordP div {
  margin: 10px 0;
  font-size: 15px;
}

.WordP h1 {
  font-size: 20px;
}

.WordP p {
  font-size: 12px;
}

</style>
<script>
export default {
  name: "ios",
  data() {
    return {
      msg: "Welcome to Your Vue.js App"
    };
  },
  mounted() {
    this.initV();
  },
  created() {

    document.title = '漫步今日益行'
  },
  methods: {
    initV() {
      document.documentElement.style.fontSize =
        document.documentElement.clientWidth / 7.5 + "px";

      var ua = window.navigator.userAgent.toLowerCase();

      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //是微信环境，弹出遮罩
        //document.getElementById('ios-mask').style.display='block';
        this.$refs.ios_mask.style.display = "block";
      } else {
        //document.getElementById('ios-mask').style.display='none';
        this.$refs.ios_mask.style.display = "none";
      }
    },
    jump() {
      window.location.href = "itms-apps://itunes.apple.com/app/id1531655695";
    }
  }
};

</script>
<!--本地网络地址：   http://192.168.31.101:8082-->
